import type { FilterSelection } from '@/scopes/prices/domain/filters/types'
import type { TransportSelectorMappedResponse } from '@/scopes/prices/domain/transports/types'
import type { TransportSelectorContext, TransportSelectorFilters } from '../types'
import type { TransportSelectorUrlBuilder } from '../urlBuilder/transportSelectorUrlBuilder'
import type { FlightSelectorApiRawResponse } from './types'
import defaultFetch from 'isomorphic-unfetch'
import { createTransportSelectorUrlBuilder, TransportType } from '../urlBuilder/transportSelectorUrlBuilder'
import { createFlightSelectorResponseMapper, type FlightSelectorResponseMapper } from './flightSelectorResponseMapper'

interface Dependencies {
  fetch: typeof defaultFetch
  flightSelectorResponseMapper: FlightSelectorResponseMapper
  transportSelectorUrlBuilder: TransportSelectorUrlBuilder
}

export interface FlightSelectorApiClient {
  getFlights: (
    criteria: TransportSelectorContext & { filterSelection: FilterSelection } & TransportSelectorFilters
  ) => Promise<TransportSelectorMappedResponse>
}

export function createFlightSelectorApiClient(dependencies: Partial<Dependencies> = {}) {
  const {
    fetch = defaultFetch,
    flightSelectorResponseMapper = createFlightSelectorResponseMapper(),
    transportSelectorUrlBuilder = createTransportSelectorUrlBuilder(),
  } = dependencies as Dependencies

  const fetchOptions: RequestInit = {
    referrerPolicy: 'no-referrer-when-downgrade',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
    },
  }

  async function getFlights(
    criteria: TransportSelectorContext & { filterSelection: FilterSelection } & TransportSelectorFilters,
  ) {
    const url = transportSelectorUrlBuilder.buildUrl(criteria, TransportType.Flight)

    const response = await fetch(url, fetchOptions)

    const data = (await response.json()) as FlightSelectorApiRawResponse

    return flightSelectorResponseMapper.map(data)
  }

  return { getFlights }
}
